import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function HowItWorksSection() {
  const steps = [{
    number: '01',
    title: 'Reconocimiento',
    description: 'Identificas dónde y por qué creaste tu armadura de hierro.'
  }, {
    number: '02',
    title: 'Descenso',
    description: 'Aplicas las técnicas biológicas para relajar tu sistema nervioso.'
  }, {
    number: '03',
    title: 'Soberanía',
    description: 'Empiezas a operar desde la suavidad, delegando y magnetizando apoyo real.'
  }];
  return <section className="py-24 bg-brown text-cream relative overflow-hidden" data-id="element-88">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-89">
        <FadeIn data-id="element-90">
          <div className="text-center mb-16" data-id="element-91">
            <h2 className="text-4xl md:text-5xl font-serif text-gold mb-4" data-id="element-92">
              ¿Cómo funciona?
            </h2>
            <p className="text-xl text-cream/70" data-id="element-93">
              Un proceso de 3 fases hacia tu liberación
            </p>
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12" data-id="element-94">
          {steps.map((step, index) => <FadeIn key={index} delay={index * 0.2} direction="up" data-id="element-95">
              <div className="relative p-8 rounded-2xl bg-brown-dark/50 border border-gold/10 hover:border-gold/30 transition-colors h-full" data-id="element-96">
                <div className="text-6xl font-serif text-gold/20 absolute top-4 right-6 font-bold" data-id="element-97">
                  {step.number}
                </div>
                <div className="relative z-10 mt-8" data-id="element-98">
                  <h3 className="text-2xl font-serif text-gold mb-4" data-id="element-99">
                    {step.title}
                  </h3>
                  <p className="text-cream/80 leading-relaxed text-lg" data-id="element-100">
                    {step.description}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}